import React from "react";
import logoImg from "images/logo.png";
import logoLightImg from "images/logo-light.png";
import LogoSvg from "./LogoSvg";
import LogoSvgDark from "./LogoSvgDark";
import Link from "componentsTemplate/Link";
import image from "./logo-white.png";

export interface LogoProps {
  img?: string;
  imgLight?: string;
}

const LogoWhite: React.FC<LogoProps> = ({
  img = logoImg,
  imgLight = logoLightImg,
}) => {
  return (
    <Link
      href="/"
      className="ttnc-logo inline-block text-primary-6000 flex-shrink-0"
    >
      {/* THIS USE FOR MY MULTI DEMO */}
      {/* IF YOU ARE MY CLIENT. PLESE DELETE THIS CODE AND YOU YOUR IMAGE PNG BY BELLOW CODE */}
      <img src={image} alt="logo-white" className="" />
    </Link>
  );
};

export default LogoWhite;
